var asActionMessage = function (action) { return ({
    action: action,
    fmcMessage: true,
}); };
var isActionMessage = function (data) {
    try {
        return 'action' in data && 'fmcMessage' in data;
    }
    catch (_a) {
        return false;
    }
};

export { asActionMessage, isActionMessage };
